import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useImages — fetches all uploaded images once and returns a slot→imageUrl map.
 *
 * The single-slot photos (hero, speaker-lula, speaker-francisca, founder-esther)
 * are collapsed to the most recent uploaded_at.
 */
export default function useImages() {
  const [bySlot, setBySlot] = useState({});
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/images`, { timeout: 8000 });
      const single = {};
      const gal = [];
      for (const img of data) {
        const fullUrl = `${process.env.REACT_APP_BACKEND_URL}${img.url}`;
        if (img.slot === "gallery") {
          gal.push({ ...img, url: fullUrl });
        } else if (!single[img.slot]) {
          single[img.slot] = fullUrl;
        }
      }
      setBySlot(single);
      setGallery(gal);
    } catch (err) {
      // Silent — the landing gracefully falls back to placeholders.
      // console.warn("useImages: failed to load images", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { bySlot, gallery, loading, reload: load };
}
